export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7977.b39cfc90.jpg";